import { render, staticRenderFns } from "./ControllersButtons.vue?vue&type=template&id=c9bf54ee&scoped=true"
import script from "./ControllersButtons.vue?vue&type=script&lang=js"
export * from "./ControllersButtons.vue?vue&type=script&lang=js"
import style0 from "./ControllersButtons.vue?vue&type=style&index=0&id=c9bf54ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bf54ee",
  null
  
)

export default component.exports